module.exports = __webpack_public_path__ + "media/images/ui__arrowRight--dark-0911bdcb8cf5af93bd89769969dfd894.png";